module.exports = __webpack_public_path__ + "static/media/success.fc661bed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alerts/success.svg
// module id = 539
// module chunks = 0